import React, {useState, useRef} from 'react'

import { Box } from '@mui/material';

import { CheckCircleOutline } from '@mui/icons-material'
import __t from "../../../lib/traduzioni";
import useBSSLogger from '../../../hooks/useBSSLogger';
import { useDebounce } from 'react-use';
import { addizionaleInUso, getCompAddizionale, getPropsCompAddizionale } from './utils/funzioni';
import { useContext } from 'react';
import StatoComparatoreContext from './contexts/StatoComparatore';
import AvatarAddizionale from './AvatarAddizionale';

const {logger} = useBSSLogger();

const CampoAddizionalePrezzo = ({addizionale, preventivo, prodotto, eseguiRicalcolo}) => {

    const [statoValoreTesto, setStatoValoreTesto] = useState({valore: null, prodotto: null, preventivo: null})

    const {methods, addizionaliById, categoriaById} = useContext(StatoComparatoreContext);
    const cambioValoreServizio = async (v, prodotto, preventivo, methods) => {

        if(prodotto !== null){                                
            const resp = await eseguiRicalcolo(preventivo, methods.getValues(`addizionali.prodotto_${prodotto.id}`), true);
            logger.debug("eseguito ricalcolo", resp, preventivo, methods.getValues(`addizionali.prodotto_${prodotto.id}`))
        }        
    }

    const Comp = getCompAddizionale(addizionale);

    const inUso = addizionaleInUso(preventivo, addizionale, methods, addizionaliById);                
    
    const compProps = getPropsCompAddizionale(prodotto, addizionale, methods, setStatoValoreTesto, preventivo, inUso, cambioValoreServizio);
    
    const booleanInUso = (["B"].includes(addizionale.tipo.value)) && ((inUso?.utilizzato ?? false) === true);        

    const [, cancel] = useDebounce(() => {
        cambioValoreServizio(statoValoreTesto.valore, statoValoreTesto.prodotto, statoValoreTesto.preventivo, methods)
    }, 800, [statoValoreTesto])

    return (

        <Box width={1} 
            mb={{xs: "0.5em", sm: "0.5em", md: "0.5em"}} 
            >
            
            <Box display={"flex"}>
                {["B"].includes(addizionale.tipo.value) && (
                    <Box sx={{px: 0.5}}>
                        <AvatarAddizionale {...{addizionale, preventivo}} disablePopper />

                    </Box>
                )}

                <Box flexGrow={1}>                                
                    <Comp {...compProps} />
                </Box>
                {booleanInUso && (
                    <Box pr={0.5} pt={1}>                                                                            
                        <CheckCircleOutline color={"primary"} />
                    </Box>
                )} 
            </Box>
            
        </Box>
    )

}

export default CampoAddizionalePrezzo